import React, { useMemo } from 'react';
import { Box, FormControlLabel, Checkbox } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { HolidayState, HolidayHandlers, HolidayRule } from '../common/types';

interface HolidaysTabProps {
    state: HolidayState;
    handlers: HolidayHandlers;
    creditHolidayRule: HolidayRule | null;
    loading: boolean;
    mode: string;
}

export const HolidaysTab: React.FC<HolidaysTabProps> = ({ state, handlers, creditHolidayRule, loading, mode }) => {
    const { t } = useTranslation();

    const columns: GridColDef[] = useMemo(
        () => [
            {
                field: 'name',
                headerName: t('settings.pay_rules.dialog.fields.tabs.table1.holidays'),
                flex: 1,
                resizable: false,
                filterable: false,
                sortable: false,
                editable: false,
                groupable: false,
            },
            {
                field: 'option',
                headerName: t('settings.pay_rules.dialog.fields.tabs.table1.conditions'),
                flex: 1,
                align: 'center',
                renderCell: (params) => (
                    <FormControlLabel
                        disabled={mode === 'info'}
                        control={<Checkbox checked={state.selected.includes(params.id as number)} onChange={() => handlers.toggleSelection(params.id as number)} />}
                        label={''}
                    />
                ),
            },
            {
                field: 'holiday_credit_rule',
                headerName: t('settings.pay_rules.dialog.fields.tabs.table1.holiday_credit_rule'),
                flex: 1,
                renderCell: (params) => <span>{state.selected.includes(params.id as number) ? (creditHolidayRule === null ? '< Predeterminado - <Ninguno> >' : creditHolidayRule.name) : ''}</span>,
            },
            {
                field: 'country',
                headerName: t('settings.pay_rules.dialog.fields.tabs.table1.country'),
                flex: 1,
                renderCell: (params) => <span>{params.row.country || '<Ninguno>'}</span>,
            },
        ],
        [state.selected, creditHolidayRule, handlers, mode, t],
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: 350, mt: 1 }}>
            <DataGrid
                rows={state.holidays}
                columns={columns}
                density="standard"
                disableColumnMenu
                initialState={{
                    pagination: {
                        paginationModel: { pageSize: 25, page: 0 },
                    },
                }}
                loading={loading}
                disableRowSelectionOnClick
                checkboxSelection
                getRowId={(row) => row.id}
                sx={{ '& .MuiDataGrid-cell': { cursor: 'pointer' } }}
                hideFooterSelectedRowCount
            />
        </Box>
    );
};
